import React from "react";

const Spinner = () => {
  return (
    <div className="spinner-wrapper">
      <div className="spinner"></div>
    </div>
  )
}

export default Spinner;